import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StatusModule } from '../status/status.module';
import { CalendarComponent } from './calendar.component';

import { DayCellComponent } from './components/day-cell/day-cell.component';
import { MobileDayCellComponent } from './components/mobile-day-cell/mobile-day-cell.component';

@NgModule({
  declarations: [CalendarComponent, DayCellComponent, MobileDayCellComponent],
  imports: [CommonModule, StatusModule],
  exports: [CalendarComponent],
})
export class CalendarModule {}
